import React, {useEffect, useState} from 'react';
import _ from "lodash";
import {
    getAllPrintfulSyncProducts,
    searchPrintfulSyncProductsWithSearchCriteria
} from "../../services/printful-sync-products-data.service";
import ShowProgressSpinner from "../../../common/ui/show-progress-spinner";
import ShowEmptyListMessage from "../../../design/components/common/show-empty-list-message";
import {PRINTFUL_SYNC_PRODUCTS_FIELDS_LIST} from "../../constants/printful-sync-products.constant";
import {syncPrintfulSyncProducts} from '../../../common/services/cloud-function-service';
import ProductImageSmall from "../../../pod/components/product-upload/product-image-small";

const defaultFilterCriteria: any = {};

const PrintfulSyncProductsList = () => {
    const [printfulSyncProductsList, setPrintfulSyncProductsList] = useState(null);
    const [filterCriteria, setFilterCriteria] = useState(defaultFilterCriteria);
    const [dataFetchInProgress, setDataFetchInProgress] = useState(true);

    const getPrintfulSyncProductsList = async () => {
        setDataFetchInProgress(true);

        const searchCriteriaList = [];

        _.forIn(filterCriteria, (value, attribute) => {
            if ((!_.isEmpty(value) || value === true) && value !== 'EMPTY') {
                searchCriteriaList.push({field: attribute, condition: '==', value: value});
            }
        });

        const printfulSyncProductsListResult = await searchPrintfulSyncProductsWithSearchCriteria(searchCriteriaList);
        // const printfulSyncProductsListResult = await getAllPrintfulSyncProducts();

        setPrintfulSyncProductsList(printfulSyncProductsListResult);
        setDataFetchInProgress(false);
    }

    useEffect(() => {
        getPrintfulSyncProductsList();
    }, [filterCriteria]);

    const refreshPrintfulSyncProductsList = async () => {
        await getPrintfulSyncProductsList();
    }

    const startPrintfulSyncProductsSyncProcess = async () => {
        setDataFetchInProgress(true);
        await syncPrintfulSyncProducts();

        await refreshPrintfulSyncProductsList();
        setDataFetchInProgress(false);
    }

    return (
        <>

            <div className="flex justify-between">

                <div className="flex justify-start items-center mt-2 -ml-2 mb-2 w-full">
                    <div className={'text-xl ml-2'}>
                        Printful Sync Products

                        {printfulSyncProductsList &&
                            <span className={'ml-2'}>({printfulSyncProductsList?.length})</span>
                        }
                    </div>

                    {/* <PrintfulSyncProductsFilters
                        filterCriteria={filterCriteria}
                        setFilterCriteria={setFilterCriteria}/>*/}

                    <div className="ml-4">
                        <ShowProgressSpinner dataFetchInProgress={dataFetchInProgress}/>
                    </div>
                </div>

                <div className="text-center w-1/3 flex items-center justify-end">
                    <div>
                        <button
                            className="button-green px-4 py-2 flex items-center justify-center"
                            onClick={startPrintfulSyncProductsSyncProcess}>
                            <span>Sync Printful Sync Products</span>
                        </button>
                    </div>
                </div>

            </div>

            <div className="flex justify-start">

                <div
                    className="w-full bg-white mt-4">

                    <ShowEmptyListMessage
                        dataList={printfulSyncProductsList}
                        dataFetchInProgress={dataFetchInProgress}
                        label={'Printful Sync Products'}/>

                    {printfulSyncProductsList?.length > 0 &&
                        <div className={'table-container overflow-y-scroll border-y border-gray-400 bg-white'}>
                            <table className="w-full">
                                <thead className="">
                                <tr>
                                    <th className="p-2 border border-gray-400 bg-gray-400 text-white w-12">S.No</th>
                                    {PRINTFUL_SYNC_PRODUCTS_FIELDS_LIST?.map((printfulSyncProductsField, rowIndex) => (
                                        <th key={`th-${rowIndex}`}
                                            className={`p-2 border border-gray-400 bg-gray-400 text-white text-left pl-2 ${printfulSyncProductsField?.cssClass}`}>{printfulSyncProductsField?.label}</th>
                                    ))}
                                </tr>
                                </thead>
                                <tbody className="">
                                {printfulSyncProductsList?.map((printfulSyncProducts, rowIndex) => (
                                    <tr key={`row-${rowIndex}`} className="border border-gray-400">
                                        <td className="p-2 border border-gray-400 m-auto">
                                            <div className="flex justify-center w-12">
                                                {rowIndex + 1}
                                            </div>
                                        </td>

                                        {PRINTFUL_SYNC_PRODUCTS_FIELDS_LIST?.map((printfulSyncProductsField, columnIndex) => (
                                            <React.Fragment key={`column-${rowIndex}-${columnIndex}`}>
                                                <td className={`p-2 border border-gray-400 m-auto ${printfulSyncProductsField?.cssClass}`}>
                                                    {printfulSyncProductsField?.optionsMap &&
                                                        <>{printfulSyncProductsField?.optionsMap[printfulSyncProducts[printfulSyncProductsField?.attribute]]?.name}</>
                                                    }

                                                    {!printfulSyncProductsField?.optionsMap && !printfulSyncProductsField?.isImage &&
                                                        <>
                                                            {printfulSyncProducts[printfulSyncProductsField?.attribute]}

                                                            {printfulSyncProductsField?.secondaryAttribute &&
                                                                <div className={'text-gray-500 text-sm'}>
                                                                    {printfulSyncProducts[printfulSyncProductsField?.secondaryAttribute]}
                                                                </div>
                                                            }
                                                        </>
                                                    }

                                                    {printfulSyncProductsField?.isImage &&
                                                        <div>
                                                            <ProductImageSmall
                                                                imageUrl={printfulSyncProducts[printfulSyncProductsField?.attribute]}/>
                                                        </div>
                                                    }
                                                </td>
                                            </React.Fragment>
                                        ))}
                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    }
                </div>

            </div>

        </>
    )
}

export default PrintfulSyncProductsList
